import React from 'react';
import styled from 'styled-components';

import SelectIcon from '../UI/Img/SelectService';

const AllIcons = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 300px;
  flex-wrap: wrap;
  margin: 2rem 0 0 0;
`;

const Service = styled.div`
  margin: 0 0.1rem 0 0;
  width: 5rem;
  position: relative;
`;

const Icon = styled.div`
  margin-left: 1rem;
  max-width: 3rem;
`;

const ServiceDescrip = styled.div`
  color: #707070;
  font: Lato;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
`;

const renderService = (servico) => {
  const props = {
    icon: servico.icon,
    label: servico.label,
    color: servico.color,
  };
  return (
    <Service key={servico.icon}>
      <Icon>
        <SelectIcon icon={props.icon} label={props.label} color={props.color} />
      </Icon>
      <ServiceDescrip>
        <p>{servico.description}</p>
      </ServiceDescrip>
    </Service>
  );
};

export const ContentServices = (section) => {
  return (
    <AllIcons>
      {section.servicos
        ? section.servicos.map(servico => renderService(servico))
        : ''}
    </AllIcons>
  );
};

export default ContentServices;



// WEBPACK FOOTER //
// ./src/components/Index/Services.jsx